import React, { useRef, useEffect, useState } from "react";
import Images from "../images";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import axiosInstance from "../Help/AxiosLogicInstance";
import { useNavigate, Link } from "react-router-dom";
import "swiper/css";
import SignIn from "./SignIn";
import LazyImg from "./LazyImg";
import "swiper/css/navigation";
import { useLocation, useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import "./ApplicationBanner.css";
const ScholarshipProgram = () => {
  let token = localStorage.getItem("token");
  const navigate = useNavigate();
  const location = useLocation();
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [swiperReady, setSwiperReady] = useState(false);
  const [showDemo, setShowDemo] = useState(false);
  const [showSignIn, setShowSignIn] = useState(false);
  const [formSource, setFormSource] = useState("");
  const { setActiveModal } = useOutletContext();
  const [isScholarshipActive, setIsScholarshipActive] = useState(true);

  useEffect(() => {
    // Wait for refs to be ready
    setSwiperReady(true);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Scholarship Program - MedEngage";
  }, []);

  // Fetch application setting to determine if scholarship is active
  useEffect(() => {
    let mounted = true;
    const fetchSetting = async () => {
      try {
        const res = await axiosInstance.get(`/api/Student/GetApplicationSettingMasterByFormId/5`);
        // API returns Data array; defensively check
        const isActive = res?.data?.Data?.[0]?.IsActive;
        if (mounted) setIsScholarshipActive(isActive === undefined ? true : !!isActive);
      } catch (err) {
        console.error('Failed to fetch scholarship application settings', err);
        // keep default true on error
      }
    };
    fetchSetting();
    return () => {
      mounted = false;
    };
  }, []);
  const [loading, setLoading] = useState(true);

  // ✅ useEffect instead of React.useEffect
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300); // loader disappears after 2s

    return () => clearTimeout(timer);
  }, []);

  const checkSubmissionCount = () => {
    if (!isScholarshipActive) {
      toast.info('Scholarship application is currently closed.');
      return;
    }
    const StudentId = localStorage.getItem("StudentId");
    if (!StudentId) {
      toast.error("Please login to continue");
      setActiveModal("signIn");
      return;
    }
    
    // Navigate directly to application
    navigate('/scholarship-application/');
  };

  const handleApplyClick = () => {
    checkSubmissionCount();
  };
  const steps = ["Research", "Planning", "Design", "Development", "Launch"];
const faqs = [
  {
    question: "What is MedEngage?",
    answer:
      "MedEngage is a Medical Talent Outreach Program that has been conceived by Metropolis to encourage their imminent medical talent in the country. We have been in the field of Laboratory Medicine for over 40+ years and our aim is to empower medical students with Scholarship and help them in their medical research.",
  },
  {
    question: "What are the categories under scholarships?",
    answer:
      "Scholarship has no categories. It extends from MBBS Year 1, Year 2, Year 3, Year 4, Internship, Post Graduation(PG), including Aspirational Districts.",
  },
  {
    question: "Have the Categories of Scholarship being increased?",
    answer:
      "No, there are no categories. We are covering entire journey from UG to PG including Internship and Research Grant.",
  },
  {
    question: "Have old categories been dissolved ?",
    answer: "No",
  },
  {
    question: "Has Scholarship being extended to all years ?",
    answer:
      "Yes, we are covering entire journey from UG, PG including Internship.",
  },
  {
    question: "Will there be just one application?",
    answer: "Yes.",
  },
  {
    question: "Will the MedEngage scholarship be renewed automatically?",
    answer:
      "No. The scholarship is not renewed automatically. You have to apply afresh each year.",
  },
  {
    question: "Can I apply in two categories ?",
    answer: "No",
  },
  {
    question: "How do I know about aspirational districts?",
    answer: (
      <>
        There are 112 Aspirational districts. You can view the full list{" "}
        <a
          href="/assets/documents/List-of-112-Aspirational-Districts-in-word.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        .
      </>
    ),
  },
  {
    question:
      "What is the process for applying for Research Grants under the Academic Research Programme?",
    answer: (
      <>
        Please check the Academic Research section of the MedEngage website{" "}
        {/* TODO: replace with the exact Academic Research section URL */}
        <a
          href="https://www.med-engage.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        .
      </>
    ),
  },
  {
    question:
      "If I am from an aspirational district but study MBBS out of my hometown aspirational district then can I apply ?",
    answer: "Yes, you can apply.",
  },
  {
    question: "Is there any application fee associated with MedEngage?",
    answer: "No, there is no application fee for MedEngage.",
  },
  {
    question: "Can we submit an application form via email?",
    answer:
      "No, all applications must be submitted through the official MedEngage portal online.",
  },
  {
    question: "Can Private college also apply?",
    answer: "Yes, students from private colleges are eligible to apply.",
  },
  {
    question: "After submitting applications what are the next steps?",
    answer:
      "After submission, applications are reviewed and shortlisted candidates will be contacted via email for further steps.",
  },
  {
    question: "Will essays be mandatory?",
    answer: "There will be no essay.",
  },
  {
    question: "When will the results be announced?",
    answer: "Feb/March 2026.",
  },
  {
    question: "Will all participants get an email after the results?",
    answer: "No, only the winners will be notified.",
  },
  {
    question: "What will be Scholarship amount for each MBBS year?",
    answer:
      "Scholarship amount for each MBBS year is written on the MedEngage website, www.med-engage.com.",
  },
  {
    question: "Where can I find the terms and conditions of the scholarship?",
    answer: (
      <>
        The terms and conditions are attached{" "}
        <a
          href="/Final_TermsConditions_MedEngage2.0_8.10.24.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        .
      </>
    ),
  },
];


  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      {loading && (
        <div
          className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div className="custom-spinner"></div>
        </div>
      )}
      <div>
        <section className="ul-breadcrumb ul-section-spacing">
          <div className="ul-container">
            <h2 className="ul-breadcrumb-title">Scholarship Program</h2>
            <ul className="ul-breadcrumb-nav">
              <li>
                <Link to="/">Home</Link>
              </li>

              <li>
                <span className="separator">
                  <i className="fa fa-arrow-right"></i>
                </span>
              </li>
              <li>Scholarship Program</li>
            </ul>
          </div>
        </section>

        <section className="ul-about ul-section-spacing ">
          <div className="ul-container">
            <div className="row row-cols-md-2 row-cols-1 align-items-center gy-4 ul-about-row">
              <div className="col">
                <div className="ul-about-txt">
                  <h2 className="ul-section-title">
                    About{" "}
                    <span>
                      <strong className="green">MedEngage</strong>
                    </span>
                  </h2>

                  <p className="ul-section-descr">
                    MedEngage was conceived more than 5 years ago with the
                    intention of nurturing and supporting young medical talent,
                    while simultaneously reinforcing existing medical knowledge.
                  </p>

                  <p className="ul-section-descr">
                    The MedEngage Scholarship Programme, under Corporate Social
                    Responsibility (CSR), supports MBBS students through both
                    scholarships and research grants. The programme is holistic,
                    as it focuses not only on academic excellence but also on
                    extra-curricular achievements, including community service
                    during the academic year.
                  </p>

                  <p className="ul-section-descr">
                    Collaboration between MedEngage by Metropolis and esteemed
                    medical college will play big role in changing the
                    healthcare research & academic landscape in India.
                  </p>
                </div>
              </div>

              <div className="col">
                <figure className="ul-about-imgs">
                  <div className="img-wrapper">
                    <LazyImg
                      src={Images.ScholorshipImage}
                      alt="Felicitation of MedEngage winner with Metropolis leadership team"
                      className="scholarship-image"
                      loading="lazy"
                    />
                  </div>
                  <figcaption className="text-center mt-2">
                    Felicitation of MedEngage winner by Chief guest and
                    Metropolis Leadership team- Dr Kirti Chadha - Chief
                    Scientific & Innovation officer and Group Head - CSR and Mr
                    Mohan Menon - Chief Marketing officer
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </section>

        <section className="stats-section">
          <div className="container">
            <h2 className="ul-section-title text-white text-center">
              Scholarship Given
            </h2>
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-number">280</div>
                <div className="stat-label">
                  Scholarship Given<br></br>
                  <span className="text-dark">In 2022-23</span>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-number">308</div>
                <div className="stat-label">
                  Scholarship Given<br></br>
                  <span className="text-dark">In 2023-24</span>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-number">365</div>
                <div className="stat-label">
                  Scholarship Given<br></br>
                  <span className="text-dark">In 2024-25</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="ul-about ul-section-spacing ">
          <div className="medengage-upgrade ul-container">
            <h3 className="ul-section-title text-center">
              MedEngage <span className="version green">2.0</span>
            </h3>

            <p className="upgrade-text">
              As we stand at the cusp of a 5-year journey coinciding with the
              establishment of the Metropolis Foundation, the CSR arm of
              Metropolis Healthcare Ltd, and a post-COVID world with artificial
              intelligence, ChatGPT, etc., we feel the need to evolve the
              program to a deeper and more advanced format in sync with current
              times and young prodigies.
            </p>

            <p className="upgrade-text">
              We also feel the need to support the government in uplifting our
              fellow Indians residing in the aspirational districts. We wish to
              cover more of the medical journey, addressing lesser privileged
              families and intelligences, requiring MedEngage to version 2.0.
              <span className="highlight-text">
                The scholarship will cover UG and PG, MD/MS/DNB, including
                internship.
              </span>
            </p>
          </div>
        </section>

        <section className="program-section py-5">
          <div className="container">
            <div className="program-header text-center mb-4">
              <h2 className="ul-section-title">
                Metropolis MedEngage Scholarship for Pursuing Excellence
              </h2>
            </div>

            <div className="tab-content">
              <div className="program-tabs-wrapper">
                <ul className="nav nav-tabs program-tabs mb-4 p-2">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link tab-link active"
                      id="objective-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#objective"
                      type="button"
                      role="tab"
                    >
                      Program Objective
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link tab-link"
                      id="details-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#details"
                      type="button"
                      role="tab"
                    >
                      Program Details
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link tab-link"
                      id="enrollment-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#enrollment"
                      type="button"
                      role="tab"
                    >
                      Enrollment Process
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link tab-link"
                      id="eligibility-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#eligibility"
                      type="button"
                      role="tab"
                    >
                      Eligibility
                    </button>
                  </li>
                </ul>
              </div>
              <div
                className="tab-pane fade show active"
                id="objective"
                role="tabpanel"
              >
                <div className="row align-items-center">
                  <div className="col-lg-7">
                    <p>
                      Metropolis Scholarship under the MedEngage outreach
                      programme is one of the important components conceived by
                      Metropolis Health Care Limited. The scholarship programme
                      is unique as it aims to recognize and acknowledge doctors
                      having outstanding academic and extra-curricular
                      achievements in a given academic year, and CSR support
                      would help strengthen their medical journey and impact the
                      health domain of the country.
                    </p>
                    <br></br>

                    <p>
                      MedEngage aims at nurturing the upcoming medical force of
                      the country by providing them with scholarships which they
                      can utilise for their academic and career endeavours.
                    </p>

                    <div className="quote-box">
                      <p className="mb-1">
                        <em>
                          "The MedEngage Scholarship opened doors I never
                          thought possible. It has relieved financial stress and
                          allowed me to focus completely on my academic goals. I
                          remain sincerely thankful for this support."
                        </em>
                      </p>
                      <div className="quote-author fw-bold text-success">
                        - Hriday Das, 4th Year MBBS, Agartala Government Medical
                        College (AD)
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-5">
                    <div className="video-frame">
                      <iframe
                        src="https://www.youtube.com/embed/QhgUcn_bMI4?si=azsQqzRs08Ol-Agi"
                        title="MedEngage Scholarship Video"
                        allowFullScreen
                        loading="lazy"
                        className="video-iframe"
                      ></iframe>

                      <div className="video-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Program Details */}
              <div className="tab-pane fade" id="details" role="tabpanel">
                <div className="text-center mb-4">
                  <h2 className="mb-2">Program Details (MedEngage 2.0)</h2>
                </div>
                <div className="text-left mb-1">
                  <p className="text-muted">
                    Metropolis MedEngage Scholarship is hereby extended to
                    following (refer below), making it more inclusive and
                    holistic, increasing beneficiaries and aligning with ethos
                    of giving back to society while fulfilling the CSR goal of
                    Education and skill building as per CSR companies act,
                    Schedule VII of CA, 2014.
                  </p>
                </div>
                <div className="d-flex flex-wrap justify-content-center align-items-start gap-4 mb-4">
                  {[
                    {
                      title: "First Year MBBS Students",
                      icon: Images.Doctors,
                    },
                    {
                      title: "Second Year MBBS Students",
                      icon: Images.Doctors,
                    },
                    {
                      title: "Third Year MBBS Students",
                      icon: Images.Doctors,
                    },
                    {
                      title: "Fourth Year MBBS Students",
                      icon: Images.Doctors,
                    },
                    {
                      title: "Students Doing Internship",
                      icon: Images.Internship,
                    },
                    {
                      title: "Aspirational Districts Support",
                      icon: Images.Location,
                    },
                    { title: "Research Grants Support", icon: Images.Search },
                  ].map((item, idx) => (
                    <div key={idx} className="wd-150">
                      <div className="circle-card d-flex flex-column align-items-center justify-content-center mx-auto">
                        {
                          <img
                            src={item.icon}
                            alt={item.title}
                            className="mb-2"
                          />
                        }
                        <p className="small fs-6">{item.title}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <p className="text-muted text-left">
                  Medical students can apply in 1 of the above categories by
                  filling the application form of the respective year as on the
                  website. Students should be pursuing the curriculum from any
                  university/college based within the Indian Operations
                  recognized by the Medical Council of India. With effect from
                  financial year 23-24, Metropolis intends to expand its support
                  to students domiciled from aspirational districts (List of
                  aspirational districts attached). The main motive is to
                  support aspirational districts is to align with national
                  strategy to support districts with low socio-aspirational
                  districts as identified by Niti-Aayog.
                </p>
              </div>

              {/* Enrollment Process */}
              <div className="tab-pane fade" id="enrollment" role="tabpanel">
                <div class="row align-items-center">
                  <div class="col-12 col-md-6 mb-4 mb-md-0">
                    <h5 class="mb-2">How to Enroll</h5>
                    <p>
                      A student or institution can easily register by filling
                      out the online form with all mandatory details. Ensure all
                      fields are completed accurately to successfully enroll in
                      the program.
                    </p>
                    {token ? (
                      <button
                        className="btn-view mb-2 mb-md-0"
                        onClick={(e) => {
                          e.preventDefault();
                          checkSubmissionCount();
                        }}
                        disabled={!isScholarshipActive}
                        title={
                          !isScholarshipActive
                            ? "Scholarship is currently closed"
                            : undefined
                        }
                      >
                        {isScholarshipActive ? "Apply" : "Closed"}
                      </button>
                    ) : (
                      <button
                        className="btn-view"
                        onClick={(e) => {
                          e.preventDefault();
                          setFormSource("/scholarship-application/"); // store source
                          setShowSignIn(true); // open modal
                        }}
                      >
                        Login
                      </button>
                    )}
                    {!isScholarshipActive && (
                      <div className="alert alert-info mb-0 mt-2">
                        Applications are currently closed. Please check back
                        later.
                      </div>
                    )}

                    {showSignIn && (
                      <SignIn
                        show={showSignIn}
                        handleClose={() => setShowSignIn(false)}
                        from={formSource} // pass extra state
                      />
                    )}
                  </div>

                  <div class="col-12 col-md-6 text-center">
                    <img
                      alt="Enroll Icon"
                      class="img-fluid w-75 rounded-3"
                      src={Images.Application}
                    />
                  </div>
                </div>
              </div>

              {/* Eligibility */}
              <div className="tab-pane fade" id="eligibility" role="tabpanel">
                <div className="row align-items-start g-3">
                  <div className="col-md-12">
                    <h5 className="mb-2">Eligibility</h5>

                    <p>
                      Medical students of any discipline doing their final year
                      MBBS, MD/DNB curriculum are eligible for the program.
                    </p>

                    <h6 className="mt-3">
                      A. Eligibility Criteria for students applying from
                      Aspirational Districts
                    </h6>
                    <ul className="list-unstyled">
                      <li>
                        <i className=" fa fa-check-circle text-success me-2"></i>{" "}
                        Scholarship support for underprivileged students is
                        available to all allopathic medical students (UG MBBS or
                        PG MD/MS/DNB).
                      </li>
                      <li>
                        <i className=" fa fa-check-circle text-success me-2"></i>{" "}
                        Students who are from Aspirational Districts can apply.
                      </li>

                      <li>
                        <i className=" fa fa-check-circle text-success me-2"></i>{" "}
                        Students studying in an Aspirational District (college
                        location) or whose hometown is in an Aspirational
                        District can apply under this category.
                      </li>
                      <li>
                        <i className=" fa fa-check-circle text-success me-2"></i>{" "}
                        The application is open to students from both government
                        and private medical colleges.
                      </li>
                      <li>
                        <i className=" fa fa-check-circle text-success me-2"></i>{" "}
                        Students/doctors must register online through the
                        MedEngage website.
                      </li>
                    </ul>

                    <h6 className="mt-3">
                      B. Students from UG, Internship and PG
                    </h6>
                    <ul className="list-unstyled">
                      <li>
                        <i className=" fa fa-check-circle text-success me-2"></i>{" "}
                        Scholarship support for underprivileged students is
                        available to all allopathic medical students (UG MBBS or
                        PG MD/MS/DNB).
                      </li>
                      <li>
                        <i className=" fa fa-check-circle text-success me-2"></i>{" "}
                        Students should be pursuing their curriculum from a
                        university/college in India recognized by the Medical
                        Council of India (MCI).
                      </li>
                      <li>
                        <i className=" fa fa-check-circle text-success me-2"></i>{" "}
                        Students from Aspirational Districts can also apply
                        under this category.
                      </li>
                      <li>
                        <i className=" fa fa-check-circle text-success me-2"></i>{" "}
                        Students studying in an Aspirational District (college
                        location) or whose hometown is in an Aspirational
                        District can apply under this category.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Scholarship Application Banner Section */}
        <section className="ul-about py-3 application-banner">
          <div className="container">
            <div className="row align-items-center">
              {/* Left Illustration */}
              <div className="col-md-6 mb-3 mb-md-0 text-center text-md-start">
                <img
                  src={Images.ScholorVector}
                  alt="scholar-vector"
                  className="img-fluid"
                />
              </div>

              {/* Right Text */}
              <div className="col-md-6 banner-text text-center text-md-start">
                <h2 className="mb-2 fw-bold">Scholarship Application</h2>
                <p className="mb-3">
                  Apply now and take your first step to success.
                </p>

                <div className="d-flex flex-wrap align-items-center gap-2 mt-3 justify-content-center p-2 justify-content-lg-start w-100">
                  {/* Demo Video Button */}
                  <button
                    className="btn-demo d-flex align-items-center"
                    onClick={() => setShowDemo(true)}
                  >
                    <img src={Images.Play} alt="play" className="me-2" />
                    Watch Demo Video
                  </button>

                  {/* Apply / Login Button */}
                  {token ? (
                    isScholarshipActive ? (
                      <button
                        className="btn-login btn-lg"
                        onClick={(e) => {
                          e.preventDefault();
                          checkSubmissionCount();
                        }}
                      >
                        Apply
                      </button>
                    ) : (
                      <div className="alert alert-info mb-0">
                        Applications are currently closed. Please check back
                        later.
                      </div>
                    )
                  ) : (
                    <button
                      className="btn-login d-flex align-items-center gap-2"
                      onClick={() => {
                        if (token) navigate("/scholarship-application/");
                        else setActiveModal("signIn"); // opens SignIn modal
                      }}
                    >
                      Login
                    </button>
                  )}

                  {showSignIn && (
                    <SignIn
                      show={showSignIn}
                      handleClose={() => setShowSignIn(false)}
                      from={formSource}
                    />
                  )}

                  {/* Arrow */}
                  <img
                    src={Images.Arrow}
                    alt="arrow"
                    className="img-fluid ms-5 arrow-image  d-none  d-none d-lg-inline-block"
                    style={{ transform: "rotate(70deg)" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Demo Video Modal */}
        {showDemo && (
          <>
            <div
              className="modal fade show"
              style={{ display: "block", zIndex: 1050 }}
              tabIndex="-1"
              role="dialog"
              aria-modal="true"
            >
              <div
                className="modal-dialog modal-dialog-centered modal-lg"
                role="document"
              >
                <div className="modal-content">
                  {/* Header */}
                  <div className="modal-header">
                    <h5 className="modal-title">Scholarship Form Demo</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowDemo(false)}
                      aria-label="Close"
                    />
                  </div>

                  {/* Body */}
                  <div className="modal-body p-3">
                    <video
                      src="https://www.med-engage.com/wp-content/uploads/2024/11/Scholarship-form-demo.mp4"
                      width="100%"
                      controls
                      style={{ borderRadius: "8px" }}
                    >
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
              </div>
            </div>

            {/* Backdrop */}
            <div
              className="modal-backdrop fade show"
              onClick={() => setShowDemo(false)}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0, 0, 0, 0.5)",
                zIndex: 1040,
                cursor: "pointer",
              }}
            />
          </>
        )}

        <section className="ul-testimonial-2 ul-section-spacing">
          <div className="ul-container">
            <div className="ul-section-heading d-flex justify-content-center align-items-center">
              <h2 className="ul-section-title text-center">
                Student <span className="green">Testimonials</span>
              </h2>
            </div>

            <div className="row ul-testimonial-2-row gy-4">
              {/* Left overview */}
              <div className="col-md-4">
                <div className="ul-testimonial-2-overview bg-dark p-3">
                  <div>
                    <h3 className="reviewer-name text-light">
                      Rutvik Bhutekar
                    </h3>
                    <span className="reviewer-role text-muted">
                      Final Year MBBS, Government Medical College, Chhatrapati
                      Sambhajinagar (AD)
                    </span>
                  </div>

                  <p className="ul-testimonial-2-overview-descr text-light">
                    "Winning the MedEngage Scholarship under the Aspirational
                    District criteria has been a turning point. It has ignited a
                    fire within me to work even harder. MedEngage continues to
                    be a strong support system for medical students and a
                    pioneer in CSR-led academic empowerment."
                  </p>
                  <div className="ul-testimonial-2-overview-reviewers">
                    <img src={Images.Test1} alt="Reviewer" />
                    <img src={Images.Test2} alt="Reviewer" />
                    <img src={Images.Test3} alt="Reviewer" />
                    <img src={Images.Test4} alt="Reviewer" />
                  </div>
                </div>
              </div>

              {/* Right slider */}
              <div className="col-md-8 position-relative">
                {swiperReady && (
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    navigation={{
                      prevEl: prevRef.current,
                      nextEl: nextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                      swiper.params.navigation.prevEl = prevRef.current;
                      swiper.params.navigation.nextEl = nextRef.current;
                    }}
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    loop={true}
                    spaceBetween={15}
                    slidesPerView={1}
                    className="ul-testimonial-2-slider"
                  >
                    <SwiperSlide>
                      <div className="ul-review ul-review-2">
                        <p className="ul-review-descr">
                          This scholarship has enabled me to pursue my dream
                          education without financial constraints. It has
                          supported my college fees, academic materials, hostel,
                          and mess expenses. I am sincerely thankful to
                          MedEngage for being the helping hand in my journey.
                        </p>
                        <div className="ul-review-bottom">
                          <div className="ul-review-reviewer">
                            <div className="reviewer-image">
                              {" "}
                              <img
                                src={Images.Test3}
                                alt="reviewer image"
                              />{" "}
                            </div>
                            <div>
                              <h3 className="reviewer-name">
                                Gauri Kishor Ghodke
                              </h3>
                              <span className="reviewer-role">
                                2nd Year MBBS, Dr. VM Government Medical
                                College, Solapur (AD)
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>

                    {/* Slide 2 */}
                    <SwiperSlide>
                      <div className="ul-review ul-review-2">
                        <p className="ul-review-descr">
                          Receiving the MedEngage Scholarship was an incredible
                          honor. It gave me the encouragement and financial
                          support I needed early in my medical education,
                          boosting my confidence and drive.
                        </p>
                        <div className="ul-review-bottom">
                          <div className="ul-review-reviewer">
                            <div className="reviewer-image">
                              {" "}
                              <img
                                src={Images.Test2}
                                alt="Reviewer"
                                className="reviewer-image"
                              />{" "}
                            </div>
                            <div>
                              <h3 className="reviewer-name">
                                Pragati Vijaywargiya
                              </h3>
                              <span className="reviewer-role">
                                1st Year MBBS, Armed Forces Medical College,
                                Pune (Non-AD)
                              </span>
                              <span className="icon">
                                <i className="flaticon-quote-2"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>

                    {/* Slide 3 */}
                    <SwiperSlide>
                      <div className="ul-review ul-review-2">
                        <p className="ul-review-descr">
                          Winning this scholarship allowed me to make my parents
                          proud and inspired my peers to aim higher. MedEngage’s
                          recognition gave me the confidence to keep pushing
                          forward in my medical journey. I am truly thankful and
                          look forward to being associated again.
                        </p>
                        <div className="ul-review-bottom">
                          <div className="ul-review-reviewer">
                            <div className="reviewer-image">
                              {" "}
                              <img
                                src={Images.Test3}
                                alt="Reviewer"
                                className="reviewer-image"
                              />
                            </div>
                            <div>
                              <h3 className="reviewer-name">
                                Nataliya Pawle 3rd year student
                              </h3>
                              <span className="reviewer-role">
                                3rd Year MBBS, Rajiv Gandhi Medical College,
                                Thane (Non-AD)
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>

                    {/* Slide 4 */}
                    <SwiperSlide>
                      <div className="ul-review ul-review-2">
                        <p className="ul-review-descr">
                          Being a part of the MedEngage journey has been really
                          great! Be it the Medtalks or the Scholarship Summit,
                          everything has been a wonderful experience. Hope that
                          more people can benefit from the same in the future 🙌🏻
                          Thank you
                        </p>
                        <div className="ul-review-bottom">
                          <div className="ul-review-reviewer">
                            <div className="reviewer-image">
                              {" "}
                              <img
                                src={Images.Test1}
                                alt="Reviewer"
                                className="reviewer-image"
                              />
                            </div>
                            <div>
                              <h3 className="reviewer-name">
                                Nataliya Pawle 3rd year
                              </h3>
                              <span className="reviewer-role">
                                Akash Mantri, Seth GS Medical College and KEM
                                Hospital
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                    {/* Slide 5 */}
                  </Swiper>
                )}

                {/* Navigation buttons */}
                <div className="ul-testimonial-2-slider-nav">
                  <button ref={prevRef} className="prev">
                    <i className="fa fa-chevron-left"></i>
                  </button>
                  <button ref={nextRef} className="next">
                    <i className="fa fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="ul-about ul-section-spacing fullpage-bg">
          <div className="text-center mb-5">
            <h2 className="ul-section-title text-dark">
              Evaluation <span className="green">Process</span>
            </h2>
            <p className="section-subtitle text-dark">
              An internal and external advisory board will evaluate the
              candidates based on the following.
            </p>
          </div>

          <div className="circular-container">
            <div className="evaluation-card card-1">
              <div className="card-icon">
                <img src={Images.Academic} alt="Academic" />
              </div>
              <h5 className="card-title text-light fss-16">
                Academic Achievements
              </h5>
              <p className="card-subtitle text-light fss-16">
                Total Percentage
              </p>
            </div>

            <div className="evaluation-card card-2">
              <div className="card-icon">
                <img src={Images.Poster} alt="Poster" />
              </div>
              <h5 className="card-title text-light fss-16">
                Posters / Paper Presentations
              </h5>
              <p className="card-subtitle text-light fss-16">
                Frequency, Content And Form
              </p>
            </div>

            <div className="evaluation-card card-3 fs-6">
              <div className="card-icon">
                <img src={Images.Publication} alt="Publication" />
              </div>
              <h5 className="card-title text-light fss-16">Publications</h5>
              <p className="card-subtitle text-light fss-16">Impact Factor</p>
            </div>

            <div className="evaluation-card card-4">
              <div className="card-icon">
                <img src={Images.Extra} alt="Extra" />
              </div>
              <h5 className="card-title text-light fss-16">
                Community Service
              </h5>
              <p className="card-subtitle text-light fss-16">
                Doing social good for community welfare
              </p>
            </div>

            <div className="evaluation-card card-5">
              <div className="card-icon">
                <img src={Images.Community} alt="Community" />
              </div>
              <h5 className="card-title text-light fss-16">
                Extra Curricular Achievements
              </h5>
              <p className="card-subtitle text-light fss-16">
                Sports, Activities & Quiz
              </p>
            </div>

            {/* Single correct SVG */}
            <svg className="circle-arrows z-1" viewBox="0 0 400 400">
              <path
                d="M200,20 A180,180 0 1,1 199.9,20"
                fill="none"
                stroke="#d2d2d2"
                strokeWidth="4"
                strokeDasharray="10 8"
                markerEnd="url(#arrow)"
                className="glow-path"
              />
            </svg>
          </div>
        </section>

        <section className="ul-stats ul-section-spacing">
          <div className="container">
            <h2 className="ul-section-title text-center text-light mb-5">
              These are the <span>categories of scholarship</span> that will be
              awarded
            </h2>

            {/* 1st row */}
            <div className="row g-4 justify-content-center">
              <div className="col-6 col-sm-6 col-lg-3 d-flex justify-content-center">
                <div className="ul-stats-item">
                  <img
                    src={Images.Doctor}
                    alt="1st year MBBS student"
                    className="img-fluid mb-2"
                  />
                  <span className="txt med fw-bold">₹ 30,000</span>
                  <span className="txt">
                    Students in 1st
                    <br />
                    year of MBBS
                  </span>
                </div>
              </div>

              <div className="col-6 col-sm-6 col-lg-3 d-flex justify-content-center">
                <div className="ul-stats-item">
                  <img
                    src={Images.Doctor}
                    alt="2nd year MBBS student"
                    className="img-fluid mb-2"
                  />
                  <span className="txt med fw-bold">₹ 30,000</span>
                  <span className="txt">
                    Students in 2nd
                    <br />
                    year of MBBS
                  </span>
                </div>
              </div>

              <div className="col-6 col-sm-6 col-lg-3 d-flex justify-content-center">
                <div className="ul-stats-item">
                  <img
                    src={Images.Doctor}
                    alt="3rd year MBBS student"
                    className="img-fluid mb-2"
                  />
                  <span className="txt med fw-bold">₹ 30,000</span>
                  <span className="txt">
                    Students in 3rd
                    <br />
                    year of MBBS
                  </span>
                </div>
              </div>

              <div className="col-6 col-sm-6 col-lg-3 d-flex justify-content-center">
                <div className="ul-stats-item">
                  <img
                    src={Images.Doctor}
                    alt="4th year MBBS student"
                    className="img-fluid mb-2"
                  />
                  <span className="txt med fw-bold">₹ 30,000</span>
                  <span className="txt">
                    Students in 4th
                    <br />
                    year of MBBS
                  </span>
                </div>
              </div>
            </div>

            {/* 2nd row */}
            <div className="row g-4 justify-content-center mt-3">
              <div className="col-6 col-sm-6 col-lg-3 d-flex justify-content-center">
                <div className="ul-stats-item">
                  <img
                    src={Images.Doctor}
                    alt="Internship MBBS student"
                    className="img-fluid mb-2"
                  />
                  <span className="txt med fw-bold">₹ 30,000</span>
                  <span className="txt d-block">
                    Students in internship
                    <br />
                    of MBBS
                  </span>
                </div>
              </div>

              <div className="col-6 col-sm-6 col-lg-3 d-flex justify-content-center">
                <div className="ul-stats-item">
                  <img
                    src={Images.Research}
                    alt="Research Grant"
                    className="img-fluid mb-2"
                  />

                  <span className="txt med fw-bold">₹ 30,000</span>
                  <span className="txt d-block">Research Grant</span>
                </div>
              </div>

              <div className="col-6 col-sm-6 col-lg-3 d-flex justify-content-center">
                <div className="ul-stats-item">
                  <img
                    src={Images.Students}
                    alt="Post-graduation students"
                    className="img-fluid mb-2"
                  />
                  <span className="txt med fw-bold">₹ 30,000</span>
                  <span className="txt d-block">
                    Students doing post-graduation (MD/MS/DNB)
                  </span>
                </div>
              </div>

              <div className="col-6 col-sm-6 col-lg-3 d-flex justify-content-center">
                <div className="ul-stats-item">
                  <img
                    src={Images.Aspirational}
                    alt="Aspirational Districts Students"
                    className="img-fluid mb-2"
                  />
                  <span className="txt med fw-bold">₹ 40,000</span>
                  <span className="txt d-block">
                    Aspirational Districts Students
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/*  <section className="ul-winner ul-section-winner ">
          <div className="winner-container winners-section">
            <div className="winners-header">
              <h2 className="ul-section-title">
                MedEngage Scholarship Winners 2023-24
              </h2>
              <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3">
                <div className="winners-arrow p-2">
                  <img src={Images.StylishArrow} alt="stylish-arrow" />
                </div>
                <div className="text-center mt-3 mt-md-0">
                  <button className="btn btn-outline-light view-all-btn p-2">
                    <Link
                      to="/winners-2023-24"
                      className="text-decoration-none"
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                    >
                      View All
                    </Link>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
 */}
        <section className="ul-section-spacing">
          <div className="container my-4 w-100">
            <div className="row justify-content-center">
              <div className="col-12 col-md-12">
                <div
                  className="alert alert-light border border-success rounded-3 p-4"
                  role="alert"
                >
                  <h5 className="alert-heading text-success">Important Note</h5>
                  <p className="mb-2">
                    MedEngage scholarship recipients must acknowledge receipt of the
                    scholarship funds upon notification by the Metropolis Healthcare
                    Limited (MHL) team. The MHL team will make up to three attempts to
                    contact each recipient. If a recipient remains unresponsive after
                    these attempts, MHL shall not be responsible for any unclaimed
                    scholarship funds.
                  </p>
                  <p className="mb-0">
                    All claims must be submitted by{" "}
                    <strong className="text-dark">31 March 2027</strong>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="faq-section">
          <div className="ul-container">
            <h2 className="ul-section-title text-center p-2 m-2">FAQs</h2>
            <div className="faq-container">
              <div className="faq-grid">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className="faq-item"
                    onClick={() => toggleFAQ(index)}
                  >
                    <div style={{ flex: 1 }}>
                      <span className="faq-question">{faq.question}</span>
                      <div
                        className={`faq-answer ${
                          openIndex === index ? "show" : ""
                        }`}
                        onClick={(e) => e.stopPropagation()} // prevents closing when clicking inside
                      >
                        {faq.answer}
                      </div>
                    </div>
                    <span className="faq-icon">
                      <img
                        src={openIndex === index ? Images.Minus : Images.Plus}
                        alt={openIndex === index ? "Minus" : "Plus"}
                      />
                    </span>
                  </div>
                ))}
              </div>
              {/*   <div className="text-center mt-4">
            <button className="btn-view">View All</button>
          </div> */}
            </div>
          </div>
        </section>
      </div>
    </>
  );

};

export default ScholarshipProgram;
